import { useState, useEffect } from "react"
import { Box, Checkbox, Stack, Text, RadioGroup, Radio } from "@chakra-ui/react"
import { useSearchParams } from "react-router-dom"


export const SideBar = () => {
    const [value, setValue] = useState()
    const [searchParams, setSearchParams] = useSearchParams()
    const initial = searchParams.get("order")
    const [order, setOrder] = useState(initial || "")


    useEffect(() => {
        let params = {

        }

        order && (params.order = order)

        setSearchParams(params)

    }, [order])

   

    console.log(order)


    return (

        <Stack mb={3}>
            <Text> Browse By:</Text>
            <hr></hr>

            <Box>

                <Stack >
                    {/* <Radio value='1' border={"1px solid grey"}>Cocktail & Party Dresses</Radio>
                    <Radio value='2' >Lounge & Casual Dresses</Radio>
                    <Radio value='3'>Maxi Dresses</Radio>
                    <Radio value='6'>Mini & Tunic Dresses</Radio>
                    <Radio value='5' >Jumpsuits</Radio> */}
                    <Checkbox value={"Cocktail&Party Dresses"}>Cocktail & Party Dresses</Checkbox>
                    <Checkbox value={"Lounge&CasualDresses"}>Lounge & Casual Dresses</Checkbox>
                    <Checkbox value={"MaxiDresses"}>Maxi Dresses</Checkbox>
                    <Checkbox value={"Mini& Tunic Dresses"}>Mini & Tunic Dresses</Checkbox>
                    <Checkbox value={"Jumpsuits"}>Jumpsuits</Checkbox>

                </Stack>

            </Box>


            <br></br>
            <Text>Filter By:</Text>


            <RadioGroup onChange={setOrder} value={order}>
                <Stack>
                    <Radio value='asc' border={"1px solid grey"} name="sort" defaultChecked={order==="asc"}>Ascending</Radio>
                    <Radio value='desc' name="sort" defaultChecked={order==="desc"}>Descending</Radio>
                </Stack>

            </RadioGroup>

            <Text>Price :</Text>
            <hr></hr>
            <Checkbox name="filter">$25-$50</Checkbox>
            <Checkbox name="filter">$50-&100</Checkbox>
            <Checkbox name="filter">$100-$150</Checkbox>
            <Checkbox name="filter">$150-$200</Checkbox>
            <Checkbox name="filter">More than $200</Checkbox>

            <Text>Brand :</Text>
            <hr></hr>
            <Checkbox >Levis</Checkbox>
            <Checkbox >Allen Solly</Checkbox>
            <Checkbox >H&M</Checkbox>
            <Checkbox >Nike</Checkbox>
            <Checkbox >ADiDAs</Checkbox>

            <Text>Color :</Text>
            <hr></hr>
            <Checkbox ><Radio bg={"black"}></Radio></Checkbox>
            <Checkbox ><Radio bg={"yellow"}></Radio></Checkbox>
            <Checkbox ><Radio bg={"blue"}></Radio></Checkbox>
            <Checkbox ><Radio bg={"red"}></Radio></Checkbox>




        </Stack>
    )
}